import { render, staticRenderFns } from "./team-page-item.vue?vue&type=template&id=a80d1714&scoped=true&"
import script from "./team-page-item.vue?vue&type=script&lang=js&"
export * from "./team-page-item.vue?vue&type=script&lang=js&"
import style0 from "./team-page-item.vue?vue&type=style&index=0&id=a80d1714&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80d1714",
  null
  
)

export default component.exports